
  import { Component, Vue } from 'vue-property-decorator'

  @Component
  export default class PagesError extends Vue {
  }
